import * as React from "react";
import { Select } from "antd";
import { PbrSelect } from "src/components/common/PbrSelect/PbrSelect";
import { FormComponentProps } from "antd/lib/form";
import { PrecatorioExpeditionType, PrecatorioExpeditionTypeLabel } from 'src/services/Enum/PrecatorioExpeditionTypeEnum';
import { useContext } from "react";
import { AuthContext } from "src/components/context/AuthContext";

interface ISelecExpeditionType {
  value: string;
  onChange: (id: string) => void;
  required: boolean;
  disabled?: boolean
}

export function SelecExpeditionType(props: ISelecExpeditionType & FormComponentProps) {
  const { currentUser } = useContext(AuthContext);
  const Option = Select.Option;
  const options = Object.keys(PrecatorioExpeditionType).filter(e => (PrecatorioExpeditionType[e] !== PrecatorioExpeditionType.PRE_PRECATORIO || currentUser?.officer?.isOfficerBTG))

  return (
    <PbrSelect
      disabled={props.disabled}
      name="expeditionType"
      size="large"
      formItemProps={{ label: "Status Precatório" }}
      formWrapper={props.form}
      showSearch
      value={props.value}
      placeholder="Selecione o status"
      onChange={e => props.onChange(String(e))}
      rules={[{ required: props.required, message: "Informe status do Precatório" }]}
    >
      <Option key={"none"} value="">Selecione o status</Option>
      {options?.map((e, i) => (
        <Option key={i.toString()} value={e}>{`${PrecatorioExpeditionTypeLabel.get(PrecatorioExpeditionType[e])}`}</Option>
      ))}
    </PbrSelect>
  );
}




// WEBPACK FOOTER //
// ./src/components/common/SelectExpeditionType/SelecExpeditionType.tsx